import { createBrowserRouter } from 'react-router-dom';
import { SignInForm } from 'apps/signIn';
import { SignUpForm } from 'apps/signUp';

export const appRouter = createBrowserRouter([
    {
        path: '/',
        element: <SignInForm />,
    },
    {
        path: '/sign-up',
        element: <SignUpForm />,
    },
]);
